import React, { useEffect, useState } from 'react';
import { ArrowUpCircleFillV7 } from './figma-icons-v7';

interface ScrollToTopButtonProps {
  target?: React.RefObject<HTMLElement | null>;
  threshold?: number; // px to show button
  className?: string;
}

const ScrollToTopButton: React.FC<ScrollToTopButtonProps> = ({ target, threshold = 200, className }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = (target?.current as HTMLElement | null) ?? document.documentElement;
    const onScroll = () => {
      try {
        const top = (el as HTMLElement).scrollTop ?? window.scrollY;
        setVisible(top > threshold);
      } catch {
        setVisible(window.scrollY > threshold);
      }
    };

    // attach
    if (el === document.documentElement) {
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      return () => window.removeEventListener('scroll', onScroll);
    } else {
      (el as HTMLElement).addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      return () => (el as HTMLElement).removeEventListener('scroll', onScroll);
    }
  }, [target, threshold]);

  const handleClick = () => {
    const el = target?.current as HTMLElement | undefined | null;
    if (el && typeof (el as any).scrollTo === 'function') {
      (el as any).scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  if (!visible) return null;

  return (
    <button
      onClick={handleClick}
      aria-label="Прокрутить вверх"
      className={`fixed right-2 bottom-2 z-[200] ${className || ''}`}
    >
      <ArrowUpCircleFillV7 size={48} />
    </button>
  );
};

export default ScrollToTopButton;
